<template>
  <div>
    <div class="p-8 bg-gray-800">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h5 class="text-xs tracking-wide font-medium uppercase text-gray-400">Products</h5>
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl flex gap-1 items-center">
              <RouterLink
                :to="{ name: 'admin.products.memberships' }"
                class="text-blue-500 hover:text-blue-700 inline-flex"
                >Memberships</RouterLink
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 inline-flex mt-1.5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M8.25 4.5l7.5 7.5-7.5 7.5"
                /></svg
              ><span>{{ product ? product.name : '...' }}</span>
            </h2>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4 space-x-2">
            <PublishUnpublish
              v-if="product && product.feature_options"
              :product-id="product.id"
              :published="isPublished"
              @changed="fetchData"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white px-4 lg:px-12 sticky top-0 z-10 border-b">
      <nav class="text-sm max-w-7xl mx-auto flex whitespace-nowrap overflow-y-auto">
        <RouterLink
          v-for="item in navigation"
          :key="item.label"
          :to="item.route"
          class="px-4 inline-flex h-12 items-center justify-center"
          :class="[
            $route.name === item.route.name
              ? 'text-blue-600 bg-gray-200'
              : 'text-gray-600 hover:bg-gray-200 hover:text-blue-900',
          ]"
        >
          {{ item.label }}
        </RouterLink>
      </nav>
    </div>
    <div class="p-8">
      <RouterView v-if="product" :key="product.updated_at" />
    </div>
  </div>
</template>

<script>
import { membershipProductsClient } from '@/api/clients/admin';
import PublishUnpublish from '@/components/Products/PublishUnpublish.vue';

export default {
  components: {
    PublishUnpublish,
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      product: null,
      categoryOptions: [],
      tagOptions: [],
      featureOptions: [],
      accountTypeOptions: [],
    };
  },
  computed: {
    isPublished() {
      return typeof this.product?.published_at === 'string';
    },
    navigation() {
      const navigationItems = [
        {
          label: this.$t('global.general'),
          permissions: null,
          route: { name: 'admin.products.memberships.membership' },
        },
        {
          label: this.$t('global.subscriptionPlans'),
          permissions: null,
          route: { name: 'admin.products.memberships.membership.subscriptionPlans' },
        },
      ];

      return navigationItems
        .filter((item) => {
          if (!item.permissions) {
            return true;
          }

          return this.$membershipHasPermissionTo(item.permissions);
        })
        .map((item) => ({
          label: item.label,
          route: item.route,
        }));
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      membershipProductsClient
        .read(this.productId, {
          include: 'media,categories,tags,feature_options,feature_permission_options,account_types',
        })
        .then((r) => {
          this.product = r.data;
          this.categoryOptions = r?.included?.category_options;
          this.tagOptions = r?.included?.tag_options;
          this.featureOptions = r?.included?.feature_options;
          this.accountTypeOptions = r?.included?.account_type_options;
        });
    },
  },
  provide() {
    const data = {
      refresh: this.fetchData,
    };
    Object.defineProperty(data, 'product', {
      enumerable: true,
      get: () => this.product,
    });
    Object.defineProperty(data, 'categoryOptions', {
      enumerable: true,
      get: () => this.categoryOptions,
    });
    Object.defineProperty(data, 'tagOptions', {
      enumerable: true,
      get: () => this.tagOptions,
    });
    Object.defineProperty(data, 'featureOptions', {
      enumerable: true,
      get: () => this.featureOptions,
    });
    Object.defineProperty(data, 'accountTypeOptions', {
      enumerable: true,
      get: () => this.accountTypeOptions,
    });

    return data;
  },
};
</script>
